@for (rich of this.richText(); track rich) {
  @switch (rich.type) {
    @case ('heading') {
      <cam-title [level]="rich.level">
        <ng-container *ngTemplateOutlet="textTemplate; context: { childrenText: rich.children }"></ng-container>
      </cam-title>
    }
    @case ('paragraph') {
      <div class="paragraph">
        <ng-container *ngTemplateOutlet="textTemplate; context: { childrenText: rich.children }"></ng-container>
      </div>
    }
  }
}

<ng-template #textTemplate let-childrenText="childrenText" [typedTemplate]="this.typeToken">
  @for (entity of childrenText; track entity) {
    @switch (entity.type) {
      @case ('text') {
        <cam-rich-paragraph-text [text]="$any(entity)"></cam-rich-paragraph-text>
      }
      @case ('link') {
        <cam-rich-paragraph-link [link]="$any(entity)"></cam-rich-paragraph-link>
      }
    }
  }
</ng-template>
